import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;

  .header-text {
    flex: 1;
  }
`;
